import * as yup from "yup";
import { createValidationSchema, validate } from "@";
import type {
  AssignDriverFormValues,
  UpdateSmsSendingDateFormValues,
} from "../types.ts";

// ============================================
// Assign Driver Validation Schema
// ============================================

export const assignDriverSchema = yup
  .object({
    driverId: validate("req"),
    verificationStages: validate("array"),
  })
  .required();

export const assignDriverDefaultValues: AssignDriverFormValues = {
  driverId: "",
  verificationStages: [],
};

// ============================================
// Update SMS Sending Date Validation Schema
// ============================================

export const updateSmsSendingDateSchema = createValidationSchema({
  dateToSendSmsNotification: validate("date"),
});

export const updateSmsSendingDateDefaultValues: UpdateSmsSendingDateFormValues =
  {
    dateToSendSmsNotification: null,
  };
